<div class="col-sm-12 no-padding">

  <h3 class="text-light-blue">
    <b>Análise de contas</b>
  </h3>
  <hr>
  <router-outlet></router-outlet>

</div>